import DTM from 'shared/helpers/DTM';

const EVENT_NAME_MWEB_FOOTER_COLLAPSED = 'mweb-footer-collapsed';
const EVENT_NAME_MWEB_FOOTER_EXPANDED = 'mweb-footer-expanded';

export const onFooterCollapse = () => DTM.track(EVENT_NAME_MWEB_FOOTER_COLLAPSED);

export const onFooterExpand = () => DTM.track(EVENT_NAME_MWEB_FOOTER_EXPANDED);
